import _slicedToArray from "/Users/lianzhaocheng/Downloads/workplace/bieyang/web/bybieyang-home/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useRef, useEffect } from 'react';
import classNames from 'classnames';
import { animated, useSpring } from '@react-spring/web';
import { useThrottleFn } from 'ahooks';
var classPrefix = "adm-scroll-mask";
export var ScrollMask = function ScrollMask(props) {
  var maskRef = useRef(null);

  var _useSpring = useSpring(function () {
    return {
      leftMaskOpacity: 0,
      rightMaskOpacity: 0,
      config: {
        clamp: true
      }
    };
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      _useSpring2$ = _useSpring2[0],
      leftMaskOpacity = _useSpring2$.leftMaskOpacity,
      rightMaskOpacity = _useSpring2$.rightMaskOpacity,
      api = _useSpring2[1];

  var _useThrottleFn = useThrottleFn(function () {
    var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var mask = maskRef.current;
    if (!mask) return;
    var scrollEl = props.scrollTrackRef.current;
    if (!scrollEl) return;
    var scrollLeft = scrollEl.scrollLeft;
    var showLeftMask = scrollLeft > 0;
    var showRightMask = scrollLeft + scrollEl.offsetWidth < scrollEl.scrollWidth;
    api.start({
      leftMaskOpacity: showLeftMask ? 1 : 0,
      rightMaskOpacity: showRightMask ? 1 : 0,
      immediate: immediate
    });
  }, {
    wait: 100,
    trailing: true,
    leading: true
  }),
      updateMask = _useThrottleFn.run;

  useEffect(function () {
    updateMask(true);
  }, []);
  useEffect(function () {
    var scrollEl = props.scrollTrackRef.current;
    if (!scrollEl) return;
    scrollEl.addEventListener('scroll', updateMask);
    return function () {
      return scrollEl.removeEventListener('scroll', updateMask);
    };
  }, []);
  return React.createElement(React.Fragment, null, React.createElement(animated.div, {
    ref: maskRef,
    className: classNames(classPrefix, "".concat(classPrefix, "-left")),
    style: {
      opacity: leftMaskOpacity
    }
  }), React.createElement(animated.div, {
    className: classNames(classPrefix, "".concat(classPrefix, "-right")),
    style: {
      opacity: rightMaskOpacity
    }
  }));
};